import React, {useState} from "react";
import { BiShowAlt, BiHide } from "react-icons/bi";


const FormInput = React.memo(
function InputField(props) {
  const [ishidden, setIsHidden] = useState(false);
  const toggleHidePass = ()=>{
    setIsHidden(!ishidden);
  }
  const { className, type, name, handleChange, errorMessage, isValid, value, placeholder} = props;
  return (
    <div className="su__input reltv-fp">
      <input
        className={`signup-input ${className}`}
        type={ishidden?'text':type}
        required
        name={name}
        placeholder={placeholder}
        autoFocus={true}
        onChange={handleChange}
        value={value}
      />
      {errorMessage && !isValid && (
          <span className="error-message">{errorMessage}</span>
      )}
      {type === "password" ? (
        <div className="lgn-pass" onClick={toggleHidePass}>
          <div tabIndex={0}>
            <span className="rem-input">
              {ishidden ? <BiShowAlt /> : <BiHide /> }
            </span>
          </div>
        </div>
      ) : null}
    </div>
  );
}
      
)
export {FormInput}